import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FeaturesBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { FeatureBlock4 as Block } from "./FeatureBlock4";
import { defaultData } from "./FeatureBlock4DefaultData";
import { defaultStyles } from "./defaultStyles";
import imagePreview from "./feature_block_4_preview.png";

export const FeatureBlock4: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Feature Block 4",
    nameI18n:
      "settings.emails.visual_builder.block_type.feature_block.feature_block_4",
    version: 1,
    category: [FeaturesBlock],
    props: {
      headerContent: {
        name: "Header Content",
        nameI18n: "settings.emails.visual_builder.prop_type.header_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      featureListContentDescription1: {
        name: "Feature 1 Description",
        nameI18n:
          "settings.emails.visual_builder.prop_type.feature_1_description",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      featureListContentDescription2: {
        name: "Feature 2 Description",
        nameI18n:
          "settings.emails.visual_builder.prop_type.feature_2_description",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      featureListContentDescription3: {
        name: "Feature 3 Description",
        nameI18n:
          "settings.emails.visual_builder.prop_type.feature_3_description",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      featureListContentImage1: {
        name: "Feature 1 Image",
        nameI18n: "settings.emails.visual_builder.prop_type.feature_1_image",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      featureListContentImage2: {
        name: "Feature 2 Image",
        nameI18n: "settings.emails.visual_builder.prop_type.feature_2_image",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      featureListContentImage3: {
        name: "Feature 3 Image",
        nameI18n: "settings.emails.visual_builder.prop_type.feature_3_image",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      imageSectionContent: {
        name: "Image Section Content",
        nameI18n:
          "settings.emails.visual_builder.prop_type.image_section_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        type: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: defaultStyles.backgroundColor,
            type: "color-without-alpha",
            nameI18n:
              "settings.emails.visual_builder.prop_type.styles.background_color",
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: defaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: defaultStyles.margin,
          },
        },
      },
    },
  },
};
